export default "__VITE_ASSET__ugLOH740__"